import createRhinoState from "react-rhino";

const { RhinoProvider, useRhinoState, useRhinoValue, useSetRhinoState } =
  createRhinoState({
    modalAceptarGrilla: false,
    modalRechazarGrilla: false,
    modalAceptar: false, // Will become a new global state
    modalRechazar: false,
  });

export { RhinoProvider, useRhinoState, useRhinoValue, useSetRhinoState };
